import { useContext } from 'react';

import { InterstitialsContext } from '../InterstitialsContext';
import { InterstitialsContextType } from '../types';

export const useInterstitials = (): InterstitialsContextType => {
  const context = useContext(InterstitialsContext);

  if (!context) {
    throw new Error(
      'useInterstitials must be used within an InterstitialsProvider',
    );
  }

  return context;
};
